/* eslint-disable */
export default {
  namespaced: true,
  state: {
    keywords: [],
  },
  getters: {
    keywords: (state) => state.keywords,
  },
  mutations: {
    clearKeywords(state) {
      state.keywords = [];
    },
    addKeyword(state, keyword) {
      state.keywords.push(keyword);
    },
  },
};
